<template>
    <div class="layout-detail-infomation">
        <!-- 1. 主要信息部分 -->
        <div class="layout-detail-info-main">
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">命主资料：</label>
                <div class="layout-detail-info-content">
                    <p>{{detailInfoData.baseInfo}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">公历生日：</label>
                <div class="layout-detail-info-content">
                    <p>{{detailInfoData.solarTime}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">农历生日：</label>
                <div class="layout-detail-info-content">
                    <p>{{detailInfoData.lunarTime}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line" v-show="detailInfoData.realSunTime != ''">
                <label class="layout-detail-info-label">真太阳时：</label>
                <div class="layout-detail-info-content">
                    <p class="p-blue">{{detailInfoData.realSunTime}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line" v-show="detailInfoData.locatStr != ''">
                <label class="layout-detail-info-label">出生地区：</label>
                <div class="layout-detail-info-content">
                    <p class="p-blue">{{detailInfoData.locatStr}}</p>
                </div>
            </div>
            <detail-other-info></detail-other-info>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">命主名称：</label>
                <div class="layout-detail-info-content">
                    <p>{{personInfo.f_name}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">出生节气：</label>
                <div class="layout-detail-info-content">命主出生于
                    <span v-for="(textArr, index) in detailInfoData.birthJQArr">
                        <span class="wd-green" v-bind:class="{'wd-blue' : index==1}">{{textArr[0]}}</span>{{textArr[1]}}
                    </span>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">节气时间：</label>
                <div class="layout-detail-info-content">
                    <p v-for="text in detailInfoData.timeJQArr">{{text}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">大运开始：</label>
                <div class="layout-detail-info-content">
                    <p v-for="text in detailInfoData.dayunStrArr">{{text}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">命局强弱：</label>
                <div class="layout-detail-info-content">
                    <p class="wd-green">{{detailInfoData.strongStr}}</p>
                </div>
            </div>
            <div class="layout-detail-info-line">
                <label class="layout-detail-info-label">命局格局：</label>
                <div class="layout-detail-info-content">
                    <p class="wd-green">{{detailInfoData.situationStr}}</p>
                </div>
            </div>
        </div>

        <!-- 2. 底部按钮 -->
        <!-- <div class="layout-detail-info-button dsp-flex">
            <div class="layout-dib-left">
                <i class="iconbg icon-btn icon-btn-bao"></i>
                <span>增加红包记录</span>
            </div>
            <div class="layout-dib-mid"></div>
            <div class="layout-dib-right">
                <i class="iconbg icon-btn icon-btn-sheng"></i>
                <span>设置生日提醒</span>
            </div>
        </div> -->
    </div>
</template>

<script>
import DetailOtherInfo from './DetailOtherInfo.vue';
export default {
  components: { DetailOtherInfo },
    name: 'DetailInfomation',
    computed: {
        personInfo() {
            return this.$store.state.detail.personInfo;
        },
        detailInfoData() {
            return this.$store.state.detail.detailInfoData;
        }
    }
}
</script>